"use strict";
var DeferObservable_1 = require('./DeferObservable');
exports.defer = DeferObservable_1.DeferObservable.create;
//# sourceMappingURL=defer.js.map


//////////////////
// WEBPACK FOOTER
// ../~/rxjs/observable/defer.js
// module id = 366
// module chunks = 0